export default "__VITE_ASSET__aoK19Toh__"